<template>
  <div class="elite-tabs-wrapper-content">
    <div class="mb-2">
      <h3>
        {{ $t("PROPERTIES.PAYMENT_DETAILS") }}
      </h3>
    </div>
    <div class="custom-header transaction-form">
      <div class="mt-2">
        {{ $t("PROPERTIES.PROPERTY_TOTAL_DUE") }} :
        {{ $formatCurrency(property.total) }}
        <br />
        {{ $t("PROPERTIES.PROPERTY_TOTAL_PAIED") }} :
        {{ $formatCurrency(property.total_paied) }}
        <br />
        <span v-if="property.total_paied > property.total">
          {{ $t("PROPERTIES.PROPERTY_TOTAL_REFUND") }} :
          {{ $formatCurrency(property.total_paied-property.total) }}  
        </span>
        
      </div>

      <!--<base-button
        type="button"
        @click="openModal"
        v-if="$currentUserCan($permissions.PERM_CREATE_PROPERTIES_PAYMENTS)"
        class="elite-button add"
      >
        <span class="btn-inner--icon">
          <i class="far fa-plus-circle"></i>
        </span>
        <span class="btn-inner--text">
          {{ $t("PROPERTY_TRANSACTIONS.ADD_TRANSACTION") }}
        </span>
      </base-button>-->
      <base-button
        type="button"
        @click="openModal"
        class="elite-button add"
      >
        <span class="btn-inner--icon">
          <i class="far fa-plus-circle"></i>
        </span>
        <span class="btn-inner--text">
          {{ $t("PROPERTY_TRANSACTIONS.ADD_TRANSACTION") }}
        </span>
      </base-button>
      <base-dropdown
        title-classes="btn dropdown-button export elite-button add"
        menu-on-bottom
        :has-toggle="false"
        >
        <template slot="title">
          <base-button>
            <span class="text">
              {{ $t("PROPERTIES.ACCOUNT_STATUS") }}
            </span>
            <span class="icon">
              <i class="far fa-chevron-down"></i>
            </span>
          </base-button>
        </template>
        <base-button
          @click="print()"
        >
          <span class="btn-inner--icon">
            <i class="far fa-print"></i>
          </span>
          <span class="btn-inner--text">
            {{ $t("PROPERTIES.PRINT") }}
          </span>
        </base-button>
        <base-button
          @click="openAccountStatusModal()"
        >
          <span class="btn-inner--icon">
            <i class="far fa-envelope"></i>
          </span>
          <span class="btn-inner--text">
            {{ $t("PROPERTIES.SEND_MAIL") }}
          </span>
        </base-button>
      </base-dropdown>
    </div>
    <div class="page-wrapper-table">
      <div class="page-wrapper-table-body">
        <properties-payment-property-list-table
          :key="renderKey"
          :filterProperty="property.id"
        />
      </div>
    </div>
    <property-transaction-form
      :property="property"
      :showModal="showModal"
      @onCloseModal="closeModal"
      @onTransactionAdded="transactionAdded"
    />
    <modal :show="showAccountStatusModal" modal-classes="modal-secondary" size="sm">
      <template slot="header">
        <div
          class="d-flex justify-content-center font-weight-700 text-uppercase w-100"
        >
          {{ $t("PROPERTIES.ACCOUNT_STATUS") }}
        </div>
      </template>
      
      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES_PAYMENTS.EMAIL')}`"
          :placeholder="$t('PROPERTIES_PAYMENTS.EMAIL')"
          v-model="dataAccountStatus.email"
        />
      </div>
      <div class="text-center">
        <base-button
            @click="sendMailAccountStatus"
            type="button"
            class="elite-button add"
        >
          <span class="btn-inner--icon mr-1">
            <i class="fa fa-envelope"></i>
          </span>
          <span class="btn-inner--text">
            {{ $t("COMMON.SEND") }}
          </span>
        </base-button>
         <base-button
            @click="closeAccountStatusModal"
            type="button"
            class="btn btn-link ml-auto"
        >
          <span class="btn-inner--text">
            {{ $t("COMMON.CLOSE") }}
          </span>
        </base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import { Button, Table, TableColumn, Tooltip } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import PropertyTransactionForm from "./PropertyTransactionForm";
import swal from "sweetalert2";
import PropertiesPaymentPropertyListTable from "../partials/PropertiesPaymentPropertyListTable.vue";

export default {
  name: "property-transaction-table",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    PropertyTransactionForm,
    PropertiesPaymentPropertyListTable,
  },

  mixins: [formMixin, requestErrorMixin],

  props: {
    filterAuctionId: {
      type: String,
      default: null,
      description: "Auction id",
    },
    property: {
      type: Object,
      default: null,
      description: "Property",
    },
    refreshView: {
      type: Function,
      default: null,
      description: "View refresh after some operation",
    },
  },

  data() {
    return {
      loading: false,
      showModal: false,
      renderKey: 0,
      showAccountStatusModal: false,
      dataAccountStatus: {
        id: null,
        email: "",
      },
    };
  },

  computed: {},

  methods: {
    closeModal(refresh, property) {
      this.showModal = false;
      this.property.total_paied = property.total_paied;
      if (refresh) {
        this.renderKey++;
      }
    },

    openModal() {
      this.showModal = true;
    },

    openAccountStatusModal(){
      this.showAccountStatusModal = true;
    },
    closeAccountStatusModal(){
      this.showAccountStatusModal = false;
    },

    async sendMailAccountStatus(){
      this.dataAccountStatus.id = this.property.id;
      if(this.dataAccountStatus.email == ""){
        this.$notify({
          type: "danger",
          message: this.$t("PROPERTIES_PAYMENTS.EMPTY_EMAIL"),
        });
        return;
      }
      try {
        this.showAccountStatusModal = false;
        swal.fire({
          title: `Chargement`,
          onBeforeOpen: () => {
            swal.showLoading();
          },
        });
        await this.$store.dispatch("properties/sendMailAccountStatus", this.dataAccountStatus);
        this.renderKey++;
        swal.close();
        this.$notify({
          type: "success",
          message: this.$t("CONTACTS.ACCOUNT_STATUS_FILE_SENDED"),
        });
      } catch (error) {
        this.showAccountStatusModal = false;
        swal.close();
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async print() {
      this.loading = true;
      swal.fire({
        title: this.$t("COMMON.LOADING"),
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        let params = {id: this.property.id};
        const response = await this.$store.dispatch(
          "properties/printAccountStatus",
          params
        );
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(url, "_blank");
        swal.close();
        this.loading = false;
      } catch (error) {
        console.log(error);
        if (error?.response?.status === 404) {
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.NO_PROPERTY_FOUND"),
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
        swal.close();
        this.loading = false;
      }
    },
    transactionAdded(){
      this.$emit("onTransactionAdded", true);
    }
  },

  watch: {},
};
</script>
<style>
  .modal-header{
    padding-bottom: 0;
  }
  .modal-header .close{
    display: none;
  }
  .modal-body{
    padding-top: 0;
  }
  .transaction-form .dropdown{
    border: 1px solid #ccc;
    border-radius: 10px;
  }
</style>
